export default "__VITE_ASSET__D62Z8vUb__"